import { useSelector } from 'react-redux'
import { MeasuresDesktop } from 'Ui/Components/measures/MeasuresDesktop'
import {ihm_viewer__dictionary, locale} from "../../../Application/i18n/i18nViewer";

/*****************************************************************
 * TOOTH MEASURES IN BOTTOM PANEL
 * ***************************************************************/

const
    teeth = {
        mUpper: {
            right: {
                title: 'Upper Right',
                teeth: [11,12,13,14,15,16,17,18]
            },
            left: {
                title: 'Upper Left',
                teeth: [21,22,23,24,25,26,27,28]
            }
        },
        mLower: {
            right: {
                title: 'Lower Right',
                teeth: [41,42,43,44,45,46,47,48]
            },
            left: {
                title: 'Lower Left',
                teeth: [31,32,33,34,35,36,37,38]
            }
        }
    },
    korkhaus = [
        'measure',
        'kVal',
        'diff',
        ''
    ],
    mainMeasures = [
        'L',
        'Lc',
        'Lm',
        'archPerimeter'
    ],
    excess = [
        'excess33',
        'excess66'
    ]/*,
    sums = [
        'sum33',
        'sum66'
    ]*/


/**
 * Component measures specification
 * @returns {JSX} - return desktop components
 */
export const Measures = props => {

    const
        { AnimationReducer } = useSelector((state) => state),
        metas = AnimationReducer.metas,
        getmeta = ( data = 'all', jaw = null , type = 'global') => {
            return type === 'global' ?
                jaw === null ? metas.measuresAnalysis[data] :
                    metas.measuresAnalysis[jaw] ?
                        metas.measuresAnalysis[jaw][data]:
                        null :
                data === 'all' ?
                    metas.measuresAnalysis[jaw] ?
                        Object.entries(metas.measuresAnalysis[jaw][type]) :
                        null:
                metas.measuresAnalysis[jaw]?
                    metas.measuresAnalysis[jaw][type][data] ?
                        metas.measuresAnalysis[jaw][type][data] ?? 0 :
                        null:
                null
        },
        biteJumpVector = useSelector((state) => state.ViewportReducer.mandiAdjust),
        biteJumpValues = [biteJumpVector.x, biteJumpVector.y, biteJumpVector.z],
        biteJump = [ihm_viewer__dictionary.BITEJUMP_X[locale()], ihm_viewer__dictionary.BITEJUMP_Y[locale()], ihm_viewer__dictionary.BITEJUMP_Z[locale()]],
        renderBiteJump = biteJumpValues.some(v => v !== 0),
        getKorkhausValues = () => getmeta('all', 'mUpper', 'korkhaus') ?? getmeta('all', 'mLower', 'korkhaus'),
        getNumeric = value => !isNaN(Number.parseFloat( value )) ? Number.parseFloat( value ).toFixed(1) : '-',
        childProps = {
            getmeta,
            getKorkhausValues,
            getNumeric,
            teeth,
            mainMeasures,
            excess,
            korkhaus,
            renderBiteJump,
            biteJump,
            biteJumpValues,
        }


    return <MeasuresDesktop {...childProps} />;
}
